import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteFilled,
  DeleteOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { Modal } from 'antd'
import React, { useState, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import uploadIcon from '../../icons/create/upload.svg'
import { getCookie } from 'helper/cookie'
import { deleteFile, saveImage } from 'api/Project/project'
import { uploadDocumentapiPost } from 'api/TaskInbox/checklist'
import loadingIcons from 'icons/three-dots.svg'
import { uniq } from 'lodash'

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
}

const img = {
  display: 'block',
  width: 72,
  height: 72,
}
let datafiles = []
let listId_repeat = []

const Image = (props) => {
  const {
    visible,
    setVisible,
    project_id,
    subtaskId,
    taskId,
    getCheckList,
    getLogList,
    titleDoc,
    listFile
  } = props
  const [files, setFiles] = useState([])
  const [files2, setFiles2] = useState([])
  const token = getCookie('access_token_admin')
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [listfile_name, setListfile_name] = useState([])
  const [visibleReplace, setVisibleReplace] = useState(false)
  const [filename_repeat, setFilename_repeat] = useState([])
  // const [status, setStatus] = useState()
  const logoUpload = async () => {
    if (listId_repeat.length > 0) {
      delete_replace()
    }
    for (let index = 0; index < files.length; index++) {
      const data = new FormData()
      data.append('uploadfile', files[index])
      data.append('project_id', project_id)
      data.append('sprintflow_id', subtaskId)
      data.append('task_id', taskId)
      data.append('kind', 16)
      try {
        setLoading(true)
        await uploadDocumentapiPost({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            files[index].status = true
            getCheckList()
            getLogList()
          } else {
            getCheckList()
            getLogList()
            files[index].status = false
          }
          setShow(true)
          console.log(res)
        })
      } catch (error) {
        files[index].status = false
        console.log(error)
      }
    }
    setLoading(false)
    await setTimeout(() => {
      setVisible(false)
      setFiles([])
      datafiles = []
      setShow(false)
    }, 500)
  }
  useEffect(() => {
    setListfile_name([])
    if (listFile.length > 0) {
      listFile?.map((item) => {
        setListfile_name((prevData) => [...prevData, {
          id: item.id,
          filename: item.filename
        }])
      })
    }
  }, [listFile])
  const checkRepeat = (listfile) => {
    listfile_name?.map((file) => {
      listfile?.map((file_upload) => {
        // console.log(file, file_upload.name)
        if (file.filename == file_upload.name) {
          setFilename_repeat((prev) => [...prev, file.filename])
          setVisibleReplace(true)
          setVisible(false)
        }
      })
    })
  }
  const handleReplaceFile = () => {
    listId_repeat = []
    files2?.map((file) => {
      listfile_name?.map((file_upload) => {
        if (file.name == file_upload.filename) {
          listId_repeat.push(file_upload.id)
        }
      })
    })
    setFilename_repeat([])
    setVisibleReplace(false)
    setVisible(true)
  }
  const cancelReplace = (e) => {
    if (e.currentTarget.id !== 'skip') {
      for (var i = files2.length - 1; i >= 0; i--) {
        for (var j = 0; j < listfile_name.length; j++) {
          if (files2[i] && (files2[i].name === listfile_name[j].filename)) {
            files2.splice(i, 1);
          }
        }
      }
    }
    setFilename_repeat([])
    setVisibleReplace(false)
    setVisible(true)
  }
  const delete_replace = () => {
    //checklist upload doc 
    listId_repeat.map((id) => {
      const data = {
        id: id,
        project_id: project_id,
        kind: 16,
      }
      try {
        deleteFile({
          params: data,
          token: token,
        }).then((response) => {
          console.log(response)
        })
      } catch (error) {
        console.log(error)
      }
    })
  }

  const showIcons = (status) => {
    if (show === true) {
      if (status === true) {
        return <CheckCircleOutlined className="icon-color" />
      } else if (status === false) {
        return <CloseCircleOutlined className="CloseCircleOutlined " />
      } else {
        return <> </>
      }
    }
  }

  const deleteImage = (path) => {
    const newFile = files.filter((item) => item.path != path)
    setFiles(newFile)
    datafiles = []
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpg,image/png,image/jpeg',
    onDrop: (acceptedFiles) => {
      checkRepeat(acceptedFiles)
      acceptedFiles.map((item) => {
        let checkrepeat = false
        files.map((item2) => {
          // console.log('ไฟลที่มีอยู่', item2.path)
          // console.log('ไฟล์ใหม่ที่เข้า', item.path)
          if (item2.path == item.path) {
            checkrepeat = true
          }
        })
        if (checkrepeat == true) {
        } else {
          datafiles.push(item)
        }
      })

      setFiles(datafiles)
      setFiles2(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
            status,
          }),
        ),
      )
      setShow(false)
    },
  })

  const onCancel = () => {
    listId_repeat = []
    setFilename_repeat([])
    setShow(false)
    setFiles2([])
    setVisible(false)
    setFiles([])
    datafiles = []
  }

  const thumbs = files.map((file) => {
    let index = 1
    return (
      <div className="box-showimage " key={file.name}>
        <div style={thumbInner}>
          <img src={file.preview} style={img} />
          <div className="right-container">
            <div className="row-1">
              <p>{file.path}</p>
              {showIcons(file.status)}
            </div>
            <DeleteOutlined
              className="delete-icon"
              onClick={() => deleteImage(file.path)}
            />
          </div>
        </div>
      </div>
    )
  })

  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview))
    },
    [files],
  )
  const modalReplaceFile = () => {
    return (
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleReplace}
        okText={'Replace'}
        onOk={handleReplaceFile}
        onCancel={(e) => cancelReplace(e)}
        cancelText={'Skip'}
        cancelButtonProps={{ id: 'skip' }}
      >
        <WarningOutlined className="exclamationCircleOutlined" />
        <h2>Upload file</h2>
        <h4>{`An item named  ${uniq(filename_repeat)}  already exists in this location. Do you want to replace it with the one you’re moving?`}</h4>
      </Modal>
    )
  }

  return (
    <>
      <Modal
        maskClosable={false}
        className="ChecklistModal"
        title={titleDoc !== undefined ? `Photo ${titleDoc}` : 'Photo'}
        visible={visible}
        onCancel={onCancel}
        okText={'Upload'}
        onOk={logoUpload}
        destroyOnClose={true}
      >
        <div className="boxUploadImage-custom">
          <h4>Upload photo</h4>
          <aside className="container-thumb">{thumbs}</aside>
          <section className="container">
            <div className="layout-uploadModal">
              <div {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                <img className="icon-color" src={uploadIcon}></img>
                <h4>Upload File</h4>
              </div>
              <div className={loading ? 'upload-image-loading-container' : 'active-waite'}>
                <img src={loadingIcons}></img>
              </div>
            </div>
          </section>
        </div>
        <div className={loading ? 'block-event' : 'active-waite'}></div>
      </Modal>
      {modalReplaceFile()}
    </>
  )
}

export default Image
